import { animate } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const NumberIncreaseAnimation = ({ from = 0, to = 97, className }) => {
  const numberRef = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const node = numberRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsInView(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(node);

    return () => {
      observer.unobserve(node);
    };
  }, []);

  useEffect(() => {
    if (!isInView) return;

    const node = numberRef.current;
    if (!node) return;

    const controls = animate(from, to, {
      duration: 2,
      onUpdate(value) {
        node.textContent = Math.round(value).toString();
      },
    });

    return () => controls.stop();
  }, [from, to, isInView]);

  return (
    <motion.span
      ref={numberRef}
      animate={isInView ? { opacity: 1, scale: 1 } : {}}
      transition={{ duration: 1 }}
      className={`text-[7.5rem] lg:text-[8.75rem] font-extrabold leading-none ${className}`}
    />
  );
};

export default NumberIncreaseAnimation;
